import { useQuery } from '@tanstack/react-query';
import { FIRST_PLAYER_LEVEL } from '@/components/features/gamification/model/utils/buildStatusRewardBenefits';
import { getStatusKey } from '@/components/features/gamification/model/utils/getStatusKey';
import { playerQueryOptions } from '@/queries/player/player.queries';
import { playerGamificationRewardsOptions } from '@/queries/playerGamificationRewards/playerGamificationRewards.queries';
import { progressStatusesQueryOptions } from '@/queries/progress-statuses/progress-statuses.queries';
import { buildGamificationRewardCards } from '../utils/buildGamificationRewardCards';

export const useGamificationRewardsGridData = () => {
  const { data: playerProfile, isPending: isPlayerProfilePending } = useQuery(playerQueryOptions.mePlayerProfile());
  const { data: progressStatuses, isPending: isProgressStatusesPending } = useQuery(progressStatusesQueryOptions.list());
  const { data: groupedRewards, isPending: isGroupedRewardsPending } = useQuery(playerGamificationRewardsOptions.meGroupedRewards());

  const playerLevel = playerProfile?.level ?? FIRST_PLAYER_LEVEL;
  const currentStatusKey = playerProfile?.progressStatus
    ? getStatusKey(playerProfile.progressStatus) ?? 'starter'
    : undefined;

  const cards = buildGamificationRewardCards({
    currentStatusKey,
    groupedRewards,
    progressStatuses: progressStatuses?.items,
    playerLevel,
  });

  return {
    cards,
    isLoading: isPlayerProfilePending || isProgressStatusesPending || isGroupedRewardsPending,
  };
};
